import {ChangeToApprove} from './tenant-setting-change';

export class ExecuteActionResult {
  constructor(
    public ChangeToApprove: ChangeToApprove,
    public resultMessage: string
  ) {

  }
}
